import store from '@/store';
import Cookies from 'js-cookie';
import constants from "./constants";
import {findDicsByCode} from '@/api/common/common';

export class AdaptiveManager {
    constructor(designWidth = 640, maxWidth = 750, bodyFontSize = '0.16rem') {
        this.designWidth = designWidth;
        this.maxWidth = maxWidth;
        this.bodyFontSize = bodyFontSize;
    }

    calcBaseFontSize() {
        var documentElement = document.documentElement;
        var baseFontSize = Math.min(documentElement.getBoundingClientRect().width, this.maxWidth) / this.designWidth * 100;
        document.documentElement.style.fontSize = baseFontSize + 'px';
        document.body.style.fontSize = this.bodyFontSize;
    }

    bindEvents() {
        window.addEventListener('resize', this.calcBaseFontSize, false);
    }

    init() {
        this.calcBaseFontSize();
        this.bindEvents();
    }
}

export function checkPermission(permissionList, permissionPath) {
    let target = null;
    permissionList.forEach(permissionItem => {
        if (permissionItem.path === permissionPath) {
            target = permissionItem;
            return false;
        } else {
            if (permissionItem.children && permissionItem.children.length !== 0) {
                target = checkPermission(permissionItem.children, permissionPath);
                return target === null;
            }
        }
    });
    return target;
}

export function checkIndexPermission(permissionList, permissionPath) {
    return permissionList.indexOf(permissionPath) !== -1;
}

export function isShowByPermission(permissionPath) {
    return store.getters.permission.indexOf(permissionPath) !== -1;
}
export function isShowByRole(comparisonValue, comparisonKey = 'constantId') {
    return store.getters.roles.findIndex(roleItem => roleItem[comparisonKey] === comparisonValue) !== -1;
}
export function hasPermission(permissionPath) {
    return store.getters.permission.indexOf(permissionPath) !== -1;
}

function setAttributes(script, attrs) {
    for (var attr in attrs) {
        script.setAttribute(attr, attrs[attr])
    }
}

export function loadScript(src, opts) {
    return new Promise(function (resolve, reject) {
        var head = document.head || document.getElementsByTagName('head')[0]
        var script = document.createElement('script')

        opts = opts || {}

        script.type = opts.type || 'text/javascript'
        script.charset = opts.charset || 'utf8'
        script.async = 'async' in opts ? !!opts.async : true
        script.src = src

        if (opts.attrs) {
            setAttributes(script, opts.attrs)
        }

        if (opts.text) {
            script.text = '' + opts.text
        }

        script.onload = function () {
            resolve(script)
            this.onerror = this.onload = null
        }

        script.onerror = function () {
            reject(script)
            this.onerror = this.onload = null
        }

        head.appendChild(script)
    })
}

export function strToHtml(str) {
    return str.replace(/&lt;|&gt;|&quot;|&#39;|&nbsp;|&amp;/g, function (matched) {
        let replaced = '';
        switch (matched) {
            case '&lt;':
                replaced = '<';
                break;
            case '&gt;':
                replaced = '>';
                break;
            case '&quot;':
                replaced = '"';
                break;
            case '&#39;':
                replaced = '\'';
                break;
            case '&nbsp;':
                replaced = ' ';
                break;
            case '&amp;':
                replaced = '&';
                break;
            default:
                break;
        }
        return replaced;
    });
}

export function encrypt(msg) {
    const CryptoJS = window.CryptoJS;
    var key = CryptoJS.enc.Utf8.parse('2019092415weiyan');
    var iv = CryptoJS.enc.Utf8.parse('weiyan2019092415');
    var passwd = CryptoJS.enc.Utf8.parse(msg.trim());
    const result = CryptoJS.AES.encrypt(passwd, key, {
        iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
    });
    return result.ciphertext.toString();
}

export function isShowByPermissionList(permissionList, isOr = true) {
    if (isOr) {
        return permissionList.some(permissionPath => {
            return isShowByPermission(permissionPath)
        })
    } else {
        return permissionList.every(permissionPath => isShowByPermission(permissionPath))
    }
}
export function isShowByRoleList(roleList, isOr = true) {
    if (isOr) {
        return roleList.some(roleId => {
            return isShowByRole(roleId)
        })
    } else {
        return roleList.every(roleId => isShowByRole(roleId))
    }
}

export function getExportUrl(path, args = {}, prefixUrl) {
    const prefix = prefixUrl || (global.command === "production" ? `https://www.zhxiaoyuan.cn/` : `https://www.weixiaojia.net/`);
    const query = [];
    Object.keys(args).forEach(key => {
        query.push(`${key}=${args[key]}`);
    });
    return `${prefix}${path}?${query.join('&')}&token=${Cookies.get('Admin-Token') || sessionStorage.token}`
}

export function parseToConstants(value, constKey) {
    if (value == null) {
        return ''
    } else {
        return constants[constKey].get(value.toString()) || '';
    }
}

export function parseToConstantsKey(value, constKey) {
    if (value == null) {
        return ''
    } else {
        const resultItem = [...constants[constKey].entries()].find(item => {
            return item[1] == value;
        });
        return resultItem ? resultItem[0] : '';
    }
}

export function getDicByCode(dicCode) {
    return new Promise((resolve, reject) => {
        findDicsByCode({
            dicCode
        })
            .then(res => res.data)
            .then(data => {
                if (data.result) {
                    resolve(data.data);
                } else {
                    reject(data.msg);
                }
            })
            .catch(error => {
                reject(error);
            });
    })
}

export function getValueFromDicCode(code, dicCode) {
    return new Promise((resolve, reject) => {
        getDicByCode(dicCode)
            .then(data => {
                const result = data.find((item => item.code == code));
                resolve(result ? result.value : '');
            })
            .catch(error => {
                reject(error);
            });
    });
}



// WEBPACK FOOTER //
// ./src/utils/utils.js